import { IFunnelRepository } from '../../../domain/repositories/IFunnelRepository';
import { IFunnelStageRepository } from '../../../domain/repositories/IFunnelStageRepository';
import { ILeadRepository } from '../../../domain/repositories/ILeadRepository';
import { NotFoundError, BusinessRuleError } from '../../../core/errors/DomainErrors';

export class DeleteFunnelUseCase {
    constructor(
        private funnelRepository: IFunnelRepository,
        private funnelStageRepository: IFunnelStageRepository,
        private leadRepository: ILeadRepository
    ) { }

    async execute(id: string): Promise<void> {
        // Busca o funil para verificar se existe
        const funnel = await this.funnelRepository.findById(id);

        if (!funnel) {
            throw new NotFoundError('Funil', id);
        }

        // Busca todas as etapas deste funil
        const stages = await this.funnelStageRepository.findAll(id);

        // Verifica se há leads em qualquer etapa do funil
        let totalLeadsCount = 0;
        for (const stage of stages) {
            const leadsInStage = await this.leadRepository.findByStage(stage.id);
            totalLeadsCount += leadsInStage.length;
        }

        if (totalLeadsCount > 0) {
            throw new BusinessRuleError(
                `Não é possível deletar o funil "${funnel.name}" pois existem ${totalLeadsCount} negociação(ões) vinculadas. ` +
                'Mova ou exclua as negociações antes de deletar o funil.'
            );
        }

        // Executa a exclusão
        await this.funnelRepository.delete(id);
    }
}
